import { memo } from "react";
import { Link } from "react-router-dom";
import {
  Smartphone, Battery, Droplets, Usb, ScanFace, Camera, Volume2,
  Laptop, Gamepad2, HardDrive, Wrench, ArrowRight,
} from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { PANNES } from "@/data/pannesData";

const ICON_MAP = {
  Smartphone, Battery, Droplets, Usb, ScanFace, Camera, Volume2,
  Laptop, Gamepad2, HardDrive,
};

// Top 6 des pannes les plus recherchées (SEO longue traîne)
const FEATURED_SLUGS = [
  "ecran-casse-iphone-niort",
  "batterie-iphone-niort",
  "desoxydation-niort",
  "connecteur-charge-iphone-niort",
  "face-id-iphone-niort",
  "recuperation-donnees-niort",
];

export const PannesSection = memo(() => {
  const featured = FEATURED_SLUGS
    .map((slug) => PANNES.find((p) => p.slug === slug))
    .filter(Boolean);

  return (
    <section className="section-padding bg-white" data-testid="home-pannes-section">
      <div className="container-custom max-w-6xl">
        <div className="text-center mb-10">
          <Badge className="bg-red-100 text-red-700 px-4 py-2 mb-4 hover:bg-red-100">
            <Wrench className="w-4 h-4 mr-1" />
            Pannes courantes
          </Badge>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
            Les réparations les plus demandées à Niort
          </h2>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto">
            Identifiez votre panne, découvrez nos tarifs transparents et notre méthode de
            réparation. Diagnostic gratuit, garantie 6 mois.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
          {featured.map((panne) => {
            const Icon = ICON_MAP[panne.icon] || Wrench;
            return (
              <Link
                key={panne.slug}
                to={`/${panne.slug}`}
                className="block group"
                data-testid={`featured-panne-${panne.slug}`}
              >
                <div className="h-full p-5 bg-white rounded-xl border-2 border-slate-100 hover:border-red-200 hover:shadow-lg transition-all duration-300">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 rounded-lg bg-red-50 flex items-center justify-center flex-shrink-0">
                      <Icon className="h-6 w-6 text-red-600" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3 className="font-bold text-base text-slate-900 group-hover:text-red-600 transition-colors mb-1 leading-snug">
                        {panne.titleH1.split(" à Niort")[0].split(" - ")[0]}
                      </h3>
                      <p className="text-sm text-slate-500 mb-2">{panne.durationLabel}</p>
                      <span className="text-sm font-bold text-red-600">
                        dès {panne.priceFrom} €
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>

        <div className="text-center">
          <Link to="/pannes-reparations">
            <Button size="lg" variant="outline" className="gap-2 border-2" data-testid="see-all-pannes-btn">
              Voir toutes les pannes traitées ({PANNES.length})
              <ArrowRight className="h-5 w-5" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
});

PannesSection.displayName = "PannesSection";
